module.exports = __webpack_public_path__ + "img/preloader.30f5dfad.svg";